import { render } from "./RatingsSM.vue?vue&type=template&id=50362a24&scoped=true"
import script from "./RatingsSM.vue?vue&type=script&lang=js"
export * from "./RatingsSM.vue?vue&type=script&lang=js"

import "./RatingsSM.vue?vue&type=style&index=0&id=50362a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50362a24"]])

export default __exports__